import script from "./CaseManagementCoachingDigitalSignatureForm.vue?vue&type=script&setup=true&lang=js"
export * from "./CaseManagementCoachingDigitalSignatureForm.vue?vue&type=script&setup=true&lang=js"

import "./CaseManagementCoachingDigitalSignatureForm.vue?vue&type=style&index=0&id=3c57bc7d&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c57bc7d"]])

export default __exports__